import request from '../../util/SuperagentUtils';
import {paymentEndpoints} from "../../requests/api-endpoints";

const handleFailure = (response) => {
  if (!response.ok) {
    throw Error(`${response.status} - ${response.statusText}`);
  }
  return response;
}

export const requestGetFailedTransactionsForBooking = (bookingId,
                                                       onSuccess,
                                                       onFail) => {
    const result = request
        .get(paymentEndpoints.getFailedPaymentsForBooking(bookingId))

    if(onSuccess && onFail) {
        result
            .then((resp) => onSuccess(resp.body))
            .catch((err) => onFail(err))
    } else {
        return result
    }
}

export const requestBookingById = async (bookingId) => {
  return handleFailure(request.get(paymentEndpoints.getBookingById(bookingId)))
}

export const getFailedBookingTransactionFees = (bookingId, paymentMethodId, bookingTransactionIds) => {
  const searchParams = new URLSearchParams();
  searchParams.append('bookingId', bookingId);
  searchParams.append('paymentMethodId', paymentMethodId);
  if (bookingTransactionIds) searchParams.append('transactionIds', bookingTransactionIds.join(','));
  return request.get(`${paymentEndpoints.bookingTransactionFeeSummary}?${searchParams.toString()}`);
}
